export * from './target.component';
export * from './targetGeneral/targetGeneral.component';